import images from "./images";

const home = [
  {
    id: 1,
    image: images.home1,
    subtitle: "Welcome to Netify",
    title: "Experience {Lightning-Fast Internet} at Home",
    price: "$49.99",
    priceUnit: "per month",
    buttonText: "Get Started",
    buttonLink: "Pricing",
  },
  {
    id: 2,
    image: images.home2,
    subtitle: "Welcome to Netify",
    title: "Enjoy {Premium Cable TV} Packages",
    price: "$59.99",
    priceUnit: "per month",
    buttonText: "Get Started",
    buttonLink: "Pricing",
  },
  {
    id: 3,
    image: images.home3,
    subtitle: "Welcome to Netify",
    title: "Reliable {Broadband Services} for All",
    price: "$39.99",
    priceUnit: "per month",
    buttonText: "Get Started",
    buttonLink: "Pricing",
  },
];

export default home;